import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Alert, Result, Radio, Input } from 'antd';
import { Button, RadioButtonGroup, RadioButton, Row, Col } from 'components/ui';
import { Loading } from 'components/blocks';
import { getQueryParam } from 'services/common';
import { UNSUBSCRIPTION_PARAM } from 'constants/common';
import './style.css';

const { Search } = Input;

const errorMessage = 'Unable to complete request. Please try again later.';

class PauseEmails extends Component {
  isUnmounted = false;

  state = {
    isSubscribed: false,
    isLoading: false,
    isRequesting: false,
    error: '',
    feedbackError: '',
    unsubscriptionToken: '',
    pausedDuration: 1,
    feedBackRadioValue: 0,
    confirmation: '',
  };

  componentDidMount() {
    this.getUnsubscribeToken();
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  getUnsubscribeToken = () => {
    const url = window.location.href;
    const token = getQueryParam(url, UNSUBSCRIPTION_PARAM);

    if (token) {
      this.setState({ unsubscriptionToken: token });
    }
  };

  resubscribe = params => {
    this.props
      .onReSubscribe(params)
      .then(response => {
        if (!response.success && !this.isUnmounted) {
          this.setState({ isLoading: false, error: errorMessage });
          return;
        }

        if (!this.isUnmounted) {
          this.setState({ isSubscribed: true, isLoading: false });
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
        if (!this.isUnmounted) {
          this.setState({ error: errorMessage, isLoading: false });
        }
      });
  };

  changeDuration = params => {
    this.props
      .onChangeDuration(params)
      .then(response => {
        if (!response.success && !this.isUnmounted) {
          this.setState({ isRequesting: false, error: errorMessage });
          return;
        }

        if (!this.isUnmounted) {
          this.setState({
            isRequesting: false,
            pausedDuration: parseInt(params.duration, 10),
          });
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
        if (!this.isUnmounted) {
          this.setState({ error: errorMessage, isLoading: false });
        }
      });
  };

  handleResubscribe = () => {
    const params = {
      [UNSUBSCRIPTION_PARAM]: this.state.unsubscriptionToken,
    };
    this.setState({ isLoading: true, error: '' });
    this.resubscribe(params);
  };

  handleDurationChange = event => {
    const params = {
      [UNSUBSCRIPTION_PARAM]: this.state.unsubscriptionToken,
      duration: event.target.value,
    };
    this.setState({ isRequesting: true, error: '' });
    this.changeDuration(params);
  };

  handleFeedBackRadioChange = event => {
    const { value } = event.target;
    this.setState({ feedBackRadioValue: value, confirmation: '' });
    if (value !== '') {
      this.handleReasonSubmit(value);
    }
  };

  handleReasonSubmit = reason => {
    if (reason !== '') {
      this.props
        .onUpdateReason({ ui: this.state.unsubscriptionToken, reason })
        .then(response => {
          if (!response.success && !this.isUnmounted) {
            this.setState({ isRequesting: false, feedbackError: errorMessage });
            return;
          }

          if (!this.isUnmounted) {
            this.setState({
              isRequesting: false,
              confirmation: 'Thank you for your feedback',
            });
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
          if (!this.isUnmounted) {
            this.setState({ feedbackError: errorMessage, isRequesting: false });
          }
        });
    }
  };

  getResubscribeContent = () => {
    const {
      isLoading,
      error,
      feedbackError,
      unsubscriptionToken,
      isRequesting,
      feedBackRadioValue,
      confirmation,
    } = this.state;

    return (
      <div>
        <br />
        {unsubscriptionToken && (
          <Row>
            <Col className="feedback-col" lg={12} sm={24} xs={24}>
              <div>
                <span>How long would you like to pause our emails?</span>
                <br />
                &nbsp;
                <br />
                {Boolean(error) && <span className="error">{error}</span>}
                <RadioButtonGroup
                  defaultValue="1"
                  disabled={isRequesting}
                  onChange={this.handleDurationChange}
                >
                  <RadioButton value="1">1 Month</RadioButton>
                  <RadioButton value="3">3 Months</RadioButton>
                  <RadioButton value="6">6 Months</RadioButton>
                  <RadioButton value="12">1 Year</RadioButton>
                  <RadioButton value="0">Forever</RadioButton>
                </RadioButtonGroup>
                <br />
                <h4>Or</h4>
                <Button
                  className="re-subscribe-button"
                  disabled={isLoading}
                  type="primary"
                  onClick={this.handleResubscribe}
                >
                  Keep getting Turing emails
                  {isLoading && <Loading size={10} />}
                </Button>
              </div>
            </Col>
            <Col lg={12} sm={24} xs={24}>
              <div className="feedback-div">
                <p>We are sorry to see you leave the platform. </p>
                <p>
                  Help us improve the platform, please tell us why you are no
                  longer interested in moving forward with your application.{' '}
                </p>
                <Radio.Group
                  value={feedBackRadioValue}
                  onChange={this.handleFeedBackRadioChange}
                >
                  <Radio className="feedback-radio" value="I found another job">
                    I found another job
                  </Radio>
                  <Radio
                    className="feedback-radio"
                    value="I’ve decided to stay at my current job"
                  >
                    I’ve decided to stay at my current job
                  </Radio>
                  <Radio
                    className="feedback-radio"
                    value="I’m not happy with Turing’s vetting process"
                  >
                    I’m not happy with Turing’s vetting process
                  </Radio>
                  <Radio
                    className="feedback-radio"
                    value="I want to improve my skills"
                  >
                    I want to improve my skills
                  </Radio>
                  <Radio className="feedback-radio" value="Too many emails">
                    Too many emails
                  </Radio>
                  <Radio
                    className="feedback-radio"
                    value="I didn't sign up to Turing"
                  >
                    I didn&apos;t sign up to Turing
                  </Radio>
                  <Radio className="feedback-radio" value="">
                    Other &nbsp;
                    {feedBackRadioValue === '' ? (
                      <Search
                        enterButton="Submit"
                        placeholder="Your reason for pausing"
                        onSearch={this.handleReasonSubmit}
                      />
                    ) : null}
                  </Radio>
                </Radio.Group>
                {Boolean(error) && <span className="error">{error}</span>}
                <div>{confirmation}</div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  };

  render() {
    const { isSubscribed, pausedDuration } = this.state;
    let pauseMessage = '';
    if (pausedDuration === 1) {
      pauseMessage = 'for 1 month';
    } else if (pausedDuration === 0) {
      pauseMessage = 'forever';
    } else {
      pauseMessage = `for ${pausedDuration} months`;
    }

    return (
      <div className="unsubscribe-body">
        {isSubscribed ? (
          <Fragment>
            <Alert
              className="re-subscription"
              message="Re-subscription successful!"
              showIcon
              type="success"
            />
            <br />
            <div>
              <h2>You have successfully re-subscribed!</h2>
              <p>
                Your re-subscription to emails from Turing was successful. You
                will continue to receive emails from Turing!
              </p>
            </div>
          </Fragment>
        ) : (
          <Result
            status="success"
            subTitle={this.getResubscribeContent()}
            title={`You have paused all Turing emails ${pauseMessage}`}
          />
        )}
      </div>
    );
  }
}

PauseEmails.propTypes = {
  onChangeDuration: PropTypes.func.isRequired,
  onReSubscribe: PropTypes.func.isRequired,
  onUpdateReason: PropTypes.func.isRequired,
};

export default PauseEmails;
